import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import './login.css'
import Alert from '../../Components/alert/Alert'
import Allestec from '../../assets/allestec.png'
import Api from '../../services/api'
import { LinkStyle } from '../../Components/localStyles/localStyles'

export default class ResetPassword extends React.Component {

  state = {username: null,password:null,confirmPassword:null, show: false, message: "",redirect:false, token: ""}

  changeValuePassword = (value) => { this.setState({ password: value.target.value }) }
  changeValueConfirmPassword = (value) => { this.setState({ confirmPassword: value.target.value }) }
  changeValueUsername = (value) => {this.setState({username: value.target.value})}
  changeValueToken = (value) => {this.setState({token: value.target.value})}
  callbackfunction = () => { this.setState({ show: false }) }


  validatePassword = () => {
    const {username, password, confirmPassword, token} = this.state;
    if (username !== null && username !== "" && password !== null && password !=='' && confirmPassword !== null && confirmPassword !=='') {

    } else {
      this.setState({ message: 'Necessário preencher todos os campos.', show: true })
      return false;
    }

    if (password == confirmPassword){

    } else{
      this.setState({ message: 'As senhas não conferem.', show: true })
      return false;
    }

    return true;
  }

  sendData = () =>{
    const validation = this.validatePassword();
    if(validation == true){
      Api.post("/replace-password",{username: this.state.username, newpassword: this.state.password, password_reset_token: this.state.token}).then((response)=>{
        console.log(response);
        if(response.status == 400){
          this.setState({ message: 'Usuário e/ou token inválido.', show: true })
        }
        if(response.status == 500){
          this.setState({ message: 'Erro ao redefinir senha.', show: true })
        }
        if(response.status == 200){
          this.setState({redirect: true});
        }
      }).catch((error)=>{
        console.log(error);
      })
    }else{

    }
  }

  render() {

    const { show, message,redirect,password,confirmPassword } = this.state
    if(redirect)
        return <Redirect to="/"></Redirect>

    return (
      <div className="login">
        {show ? <Alert show={show} message={message} parentCallback={this.callbackfunction} /> : null}
        <section className="login-form">
          <form className="form-sec-login" action="" autocomplete="off">
            <div className="title-login"><img src={Allestec} ></img></div>
            {/* <p style={{marginBottom:'10%'}}>Defina uma nova senha.</p> */}
            <div className="input-block">
              <input
                placeholder="Usuário"
                id="login-email"
                value={this.state.username}
                onChange={this.changeValueUsername}
              />
            </div>
            <div className="input-block">
              <input
                placeholder="Token"
                id="login-email"
                type="password"
                value={this.state.token}
                onChange={this.changeValueToken}
              />
            </div>
            <div className="input-block">
              <input
                placeholder="Nova senha"
                id="login-email"
                type="password"
                value={this.state.password}
                onChange={this.changeValuePassword}
              />
            </div>
            <div className="input-block">
              <input
                placeholder="Confirmar senha"
                id="login-email"
                type="password"
                value={this.state.confirmPassword}
                onChange={this.changeValueConfirmPassword}
              />
            </div>
            <div className="spaceButton">
              <button className="btn-login" onClick={()=>this.sendData()}>Enviar</button>
              
            </div>
            <Link style={LinkStyle}  to="/"> 
                    <button type="submit" className="btn-login" >Voltar </button>
              </Link>
          </form>
        </section>
      </div>
    )
  }
}